import { NgIf } from '@angular/common';
import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	Input,
	OnInit
} from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { Subject, interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserPaymentsApiService } from 'src/app/api/services';
import { SafeUrlPipe } from 'src/shared/pipes/safe-url.pipe';
import { CustomSpinnerService } from 'src/shared/services/helpers/custom-spinner.service';
import { EventsService } from 'src/shared/services/helpers/events.service';

@Component({
	selector: 'vl-payrexx-iframe-wrapper',
	templateUrl: './payrexx-iframe-wrapper.component.html',
	styleUrls: ['./payrexx-iframe-wrapper.component.scss'],
	imports: [NgIf, SafeUrlPipe],
})
export class PayrexxIframeWrapperComponent implements OnInit, AfterViewInit {
	@Input() payrexxUrl;
	@Input() paymentId;

	private notifier: Subject<any> = new Subject<any>();


	constructor(private cd: ChangeDetectorRef,
				private spinner: CustomSpinnerService,
				private paymentService: UserPaymentsApiService,
				private modalController: ModalController,
				private eventsService: EventsService) {
	}

	ngOnInit() {
		this.handleUpdates();
		this.interval();
		this.eventsService.$appResumeObs
			.pipe(
				takeUntil(this.notifier)
			)
			.subscribe(() => {
				this.checkStatus();
			});
	}

	public ngAfterViewInit(): void {
		this.showFrame();
		this.spinner.hide();
	}

	handleUpdates() {
		window.addEventListener('message', (e) => {
			console.log('message', e);
			if (typeof e.data === 'string') {
				try {
					const data = JSON.parse(e.data);
					console.log('data', data);
					if (data && data.payrexx) {
						// jQuery.each(data.payrexx, function (name, value) {
						// 	switch (name) {
						// 		case 'transaction':
						// 			if (typeof value === 'object') {
						// 				if (value.status === 'confirmed') {
						// 					//handling success
						// 				} else {
						// 					//handling failure
						// 				}
						// 			}
						// 			break;
						// 	}
						// });
					}
				} catch (e) {
				}
			}
		}, false);
	}

	showFrame() {
		setTimeout(() => {
			const iFrame: any = document.getElementById('payrexx');
			let origin = window.location.origin;
			console.log('iFrame - ', origin, iFrame);
			iFrame.contentWindow.postMessage(
				JSON.stringify({
					origin: origin
				}),
				iFrame.src
			);
			this.cd.detectChanges();
		}, 1000)
	}

	private checkStatus() {
		this.paymentService.getPayment({
			paymentId: this.paymentId
		}).subscribe(p => {
			console.log(p);
			if (p.paymentStatus === 'COMPLETED' || p.paymentStatus === 'CANCELLED' || p.paymentStatus === 'ERROR') {
				this.stopInterval();
				this.modalController.dismiss(p.paymentStatus);
			}
		});
	}

	private interval() {
		interval(2000)
			.pipe(
				takeUntil(this.notifier)
			).subscribe(() => {

			this.checkStatus();
		})
	}

	private stopInterval() {
		this.notifier.next('');
		this.notifier.complete();
	}
}
